export default [
    '$timeout',
    '$state',
    'UriService',
    'WebClientService',
    function ($timeout, $state, uriService, webClientService) {
        const validateThreemaId = (id) => {
            return id !== undefined && id !== null && /^([a-zA-Z0-9\*][a-zA-Z0-9]{7})$/.test(id);
        };
        const viewReceiver = (receiver) => {
            return function (e) {
                if (!receiver) {
                    return false;
                }
                $state.go('messenger.home.detail', receiver);
            };
        };
        const addAction = (params) => {
            return function (e) {
                if (!validateThreemaId(params.id)) {
                    return false;
                }
                e.preventDefault();
                const contactReceiver = webClientService.contacts.get(params.id);
                if (contactReceiver) {
                    return viewReceiver(contactReceiver)(e);
                }
                $state.go('messenger.home.create', {
                    type: 'contact',
                    initParams: {
                        identity: params.id,
                    },
                });
            };
        };
        const composeAction = (params) => {
            return function (e) {
                if (!validateThreemaId(params.id)) {
                    return false;
                }
                const text = params.text || '';
                $state.go('messenger.home.conversation', {
                    type: 'contact',
                    id: params.id,
                    initParams: {
                        text: text,
                    },
                });
            };
        };
        const getThreemaActionHandler = (name) => {
            switch (name.toLowerCase()) {
                case 'add':
                    return addAction;
                case 'compose':
                    return composeAction;
                default:
                    return null;
            }
        };
        return {
            restrict: 'A',
            scope: {},
            link(scope, el, attrs) {
                $timeout(() => {
                    for (let i = 0; i < el[0].childNodes.length; i++) {
                        const node = el[0].childNodes[i];
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            switch (node.tagName.toLowerCase()) {
                                case 'a':
                                    const link = node.innerText;
                                    if (link !== undefined) {
                                        if (link.toLowerCase().startsWith('threema://')) {
                                            const matches = (/\bthreema:\/\/([a-z]+)\?([^\s]+)\b/gi).exec(link);
                                            if (matches !== null) {
                                                const handler = getThreemaActionHandler(matches[1]);
                                                const params = uriService.parseQueryParams(matches[2]);
                                                if (handler !== null && params !== null) {
                                                    node.addEventListener('click', handler(params));
                                                }
                                            }
                                        }
                                        else if (link.toLowerCase().startsWith('https://threema.id/')) {
                                            const matches = (/\bhttps:\/\/threema\.id\/([a-zA-Z0-9\*][a-zA-Z0-9]{7})\b/gi).exec(link);
                                            if (matches !== null) {
                                                node.addEventListener('click', addAction({ id: matches[1] }));
                                            }
                                        }
                                    }
                                    break;
                                case 'span':
                                    const mentionCssClass = 'mention id';
                                    const cls = node.getAttribute('class');
                                    if (cls.substr(0, mentionCssClass.length) === mentionCssClass) {
                                        const identity = cls.substring(mentionCssClass.length).trim();
                                        if (validateThreemaId(identity)) {
                                            const contactReceiver = webClientService.contacts.get(identity);
                                            node.addEventListener('click', viewReceiver(contactReceiver));
                                            node.setAttribute('class', cls + ' link');
                                            node.setAttribute('title', contactReceiver.displayName);
                                        }
                                    }
                                default:
                            }
                        }
                    }
                }, 0);
            },
        };
    },
];
